import { ProductSearchListItemProps } from "@/components/ProductSearch/components/v2/ProductSearchListItem";
import normalizeHref from "@/utils/functions/normalizeHref";

/**
 * Maps an Algolia hit to ProductSearchListItem props format
 */
export const mapAlgoliaHitToListItem = (
  hit: any,
  index: number = 0,
): ProductSearchListItemProps => {
  // Extract partner information
  const partnerKey = hit?.partnerKeys?.[0] || hit?.partner_keys?.[0] || "";
  const partnerName =
    hit?.partnerName ||
    hit?._highlightResult?.partner?.[0]?.value ||
    partnerKey;

  // Algolia returns the product slug URL without a leading slash, causing issues with navigation.
  // Ensure the href starts with a leading slash.
  const rawHref = hit?.productSlug || "";
  const href = normalizeHref(rawHref);

  return {
    id: hit?.productUuid || hit?.uuid || hit?.objectID,
    productName: hit?.productName || hit?.title || "",
    productCategory: hit?.attributes?.[0] || hit?.subject?.[0] || "",
    partner: {
      key: partnerKey,
      fullName: partnerName,
    },
    partnerLogoUrl:
      hit?.partnerLogoOverride ||
      hit?.partnerLogoUrl ||
      hit?.owners?.[0]?.logoImageUrl ||
      "",
    timeToComplete: hit?.weeksToComplete || hit?.weeks_to_complete || undefined,
    href,
    variant: hit?.product || "",
    index,
  };
};

/**
 * Maps an array of Algolia hits to ProductSearchListItem props
 */
export const mapAlgoliaHitsToListItems = (
  hits: any[],
): ProductSearchListItemProps[] => {
  return hits.map((hit, index) => mapAlgoliaHitToListItem(hit, index));
};
